export { default as Img200 } from './processed/200/Pride-And-Prejudice-landscape.jpg';
export { default as Img400 } from './processed/400/Pride-And-Prejudice-landscape.jpg';
export { default as Imgthumb } from './processed/thumb/Pride-And-Prejudice-landscape.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/Pride-And-Prejudice-landscape.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/Pride-And-Prejudice-landscape.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      205,
      145,
      64
    ],
    "_population": 1253,
    "_hsl": [
      0.09574468085106382,
      0.5850622406639004,
      0.5274509803921569
    ]
  },
  "LightVibrant": {
    "_rgb": [
      244,
      173,
      96
    ],
    "_population": 146,
    "_hsl": [
      0.08671171171171171,
      0.8705882352941179,
      0.6666666666666667
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      99,
      46,
      26
    ],
    "_population": 3531,
    "_hsl": [
      0.04566210045662101,
      0.584,
      0.2450980392156863
    ]
  },
  "Muted": {
    "_rgb": [
      122,
      85,
      61
    ],
    "_population": 280,
    "_hsl": [
      0.06557377049180325,
      0.33333333333333337,
      0.3588235294117647
    ]
  },
  "LightMuted": {
    "_rgb": [
      220,
      188,
      188
    ],
    "_population": 1,
    "_hsl": [
      0,
      0.3137254901960785,
      0.8
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/Pride-And-Prejudice-landscape.js